export const FETCH_USER_IDENTIFICATIONS = 'FETCH_USER_IDENTIFICATIONS';
export const FETCH_APPLICATIONS = 'FETCH_APPLICATIONS';
export const FETCH_CLIENT_SCOPES = 'FETCH_CLIENT_SCOPES';
export const FETCH_CLIENT_API_KEYS = 'FETCH_CLIENT_API_KEYS';
